import React from 'react'
import PropTypes from 'prop-types'

const Svg = ({ style, className }) => (
	<svg
		width="144"
		height="76"
		viewBox="0 0 144 76"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={style}
		className={className}
	>
		<path
			d="M8.54236 60.0967C7.86839 60.0967 7.32202 59.5503 7.32202 58.8763C7.32202 58.2024 7.86839 57.656 8.54236 57.656H135.458C136.132 57.656 136.678 58.2024 136.678 58.8763C136.678 59.5503 136.132 60.0967 135.458 60.0967H8.54236Z"
			fill="#333333"
		/>
		<path
			d="M1.22034 60.0967C0.546364 60.0967 0 59.5503 0 58.8763C0 58.2024 0.546364 57.656 1.22034 57.656H5.28814C5.96211 57.656 6.50847 58.2024 6.50847 58.8763C6.50847 59.5503 5.96211 60.0967 5.28814 60.0967H1.22034Z"
			fill="#333333"
		/>
		<path
			d="M138.712 60.0967C138.038 60.0967 137.492 59.5503 137.492 58.8763C137.492 58.2024 138.038 57.656 138.712 57.656H142.78C143.454 57.656 144 58.2024 144 58.8763C144 59.5503 143.454 60.0967 142.78 60.0967H138.712Z"
			fill="#333333"
		/>
		<path
			opacity="0.3"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M80.1194 75.9611C97.1934 75.9611 111.035 74.8683 111.035 73.5204C111.035 72.1724 97.1934 71.0797 80.1194 71.0797C63.0453 71.0797 49.2041 72.1724 49.2041 73.5204C49.2041 74.8683 63.0453 75.9611 80.1194 75.9611Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M91.1999 37.2193C82.9962 29.0145 69.9364 28.2866 60.8718 35.5291C51.8072 42.7716 49.6346 55.67 55.8264 65.4824C48.6833 65.8729 43.3138 67.321 43.3138 69.0457C43.3138 71.0796 50.6847 72.7068 59.7152 72.7068H87.6366C88.3465 72.7068 88.922 72.1313 88.922 71.4213C89.7223 70.8141 90.4832 70.1565 91.1999 69.4525C95.4774 65.1798 97.8809 59.3819 97.8809 53.3359C97.8809 47.29 95.4774 41.4921 91.1999 37.2193V37.2193Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M92.055 70.3232C96.569 65.8143 99.1013 59.7058 99.1013 53.336C99.1013 46.9663 96.5691 40.8578 92.0626 36.3562C83.4194 27.7121 69.6601 26.9454 60.1101 34.5758C51.0859 41.786 48.545 54.3167 53.7963 64.3973C46.7675 64.974 42.0935 66.4955 42.0935 69.0458C42.0935 72.2202 49.7668 73.9271 59.7152 73.9271H87.6366C88.7891 73.9271 89.7599 73.149 90.0523 72.0894C90.7509 71.537 91.4194 70.9474 92.055 70.3232ZM61.6336 36.4826C70.2126 29.6281 82.5728 30.3169 90.3376 38.0828C94.3859 42.1266 96.6606 47.6139 96.6606 53.336C96.6606 59.058 94.3859 64.5454 90.3376 68.5892C89.6651 69.2496 88.9434 69.8733 88.1844 70.4493C87.8803 70.68 87.7017 71.0397 87.7017 71.4214C87.7017 71.4574 87.6725 71.4865 87.6366 71.4865H59.7152C51.5463 71.4865 44.5342 69.9267 44.5342 69.0458C44.5342 68.434 49.464 67.0524 55.893 66.7009C56.8228 66.6501 57.3554 65.6187 56.8585 64.8312C50.9984 55.5445 53.0546 43.3371 61.6336 36.4826Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M97.1064 58.0627C97.5303 58.4892 98.1548 58.6471 98.7305 58.4733C99.3061 58.2996 99.739 57.8226 99.8563 57.2329L100.816 52.3516C100.923 51.8207 100.758 51.2718 100.377 50.8871L99.2542 49.9271C99.2542 49.9271 101.89 36.4546 122.343 15.3183C123.573 14.055 123.573 12.0421 122.343 10.7787L117.689 6.14139C116.426 4.91165 114.413 4.91165 113.15 6.14139C91.9973 26.5292 79.1105 29.7346 79.1105 29.7346L78.0041 28.6282C77.6159 28.2419 77.0594 28.0768 76.5234 28.1888L71.7397 29.1488C71.1676 29.2877 70.7153 29.7248 70.5567 30.2916C70.3981 30.8585 70.558 31.4668 70.9749 31.8824L97.1064 58.0627Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			d="M96.0982 46.1355C96.5748 46.612 96.5748 47.3847 96.0982 47.8613C95.6216 48.3379 94.849 48.3379 94.3724 47.8613L81.1439 34.6328C80.6674 34.1562 80.6674 33.3836 81.1439 32.907C81.6205 32.4304 82.3932 32.4304 82.8697 32.907L96.0982 46.1355Z"
			fill="#333333"
		/>
		<path
			d="M100.854 48.0576C101.033 48.7074 100.651 49.3792 100.001 49.558C99.3512 49.7368 98.6795 49.3549 98.5007 48.7051L91.4715 23.1594C91.2927 22.5095 91.6746 21.8378 92.3244 21.659C92.9742 21.4802 93.6459 21.862 93.8247 22.5119L100.854 48.0576Z"
			fill="#333333"
		/>
		<path
			d="M105.524 38.1696C105.665 38.8288 105.244 39.4769 104.585 39.6171C103.925 39.7572 103.277 39.3365 103.137 38.6773L98.7113 17.8664C98.5711 17.2072 98.9918 16.5591 99.6511 16.4189C100.31 16.2787 100.958 16.6995 101.099 17.3587L105.524 38.1696Z"
			fill="#333333"
		/>
		<path
			d="M111.87 28.6518C112.01 29.3111 111.589 29.9589 110.929 30.0986C110.27 30.2383 109.622 29.8171 109.483 29.1578L105.838 11.9591C105.698 11.2998 106.119 10.652 106.779 10.5123C107.438 10.3726 108.086 10.7938 108.226 11.4531L111.87 28.6518Z"
			fill="#333333"
		/>
		<path
			d="M118.509 20.5158C118.649 21.175 118.228 21.823 117.569 21.9629C116.909 22.1029 116.262 21.6819 116.122 21.0227L112.867 5.6952C112.727 5.03592 113.148 4.38799 113.808 4.24802C114.467 4.10805 115.115 4.52902 115.255 5.1883L118.509 20.5158Z"
			fill="#333333"
		/>
		<path
			d="M79.5267 30.6762C78.8808 30.4837 78.5133 29.804 78.7059 29.1581C78.8984 28.5122 79.5781 28.1447 80.224 28.3373L105.493 35.8708C106.139 36.0634 106.507 36.7431 106.314 37.389C106.121 38.0349 105.442 38.4024 104.796 38.2098L79.5267 30.6762Z"
			fill="#333333"
		/>
		<path
			d="M88.5877 26.405C87.9284 26.2653 87.5072 25.6176 87.6469 24.9582C87.7866 24.2989 88.4343 23.8776 89.0937 24.0174L110.441 28.5407C111.101 28.6805 111.522 29.3282 111.382 29.9875C111.243 30.6469 110.595 31.0681 109.936 30.9284L88.5877 26.405Z"
			fill="#333333"
		/>
		<path
			d="M97.8622 20.0104C97.2029 19.8707 96.7817 19.2229 96.9214 18.5636C97.0612 17.9042 97.709 17.4831 98.3683 17.6228L116.023 21.3652C116.682 21.505 117.103 22.1527 116.963 22.8121C116.824 23.4714 116.176 23.8926 115.516 23.7528L97.8622 20.0104Z"
			fill="#333333"
		/>
		<path
			d="M106.192 13.4042C105.533 13.264 105.112 12.6159 105.252 11.9567C105.393 11.2974 106.041 10.8767 106.7 11.0169L122.385 14.3525C123.045 14.4927 123.465 15.1407 123.325 15.7999C123.185 16.4592 122.537 16.8799 121.878 16.7398L106.192 13.4042Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M69.3815 29.9629C69.1039 30.9549 69.3839 32.0195 70.1134 32.7467L96.242 58.9241C96.9838 59.6696 98.0762 59.9455 99.0831 59.6416C100.09 59.3376 100.848 58.5029 101.053 57.4709L102.014 52.587C102.199 51.6622 101.911 50.7016 101.244 50.0284L100.622 49.4938C100.75 49.0396 100.92 48.5079 101.135 47.9008C101.823 45.9666 102.827 43.7004 104.205 41.1245C108.17 33.7136 114.349 25.3343 123.22 16.167C124.908 14.4324 124.908 11.6646 123.218 9.92749L118.551 5.27697C116.804 3.57602 114.036 3.57602 112.299 5.26691C103.12 14.1137 94.8353 20.3876 87.5928 24.5237C85.0745 25.9619 82.8707 27.03 80.9991 27.7831C80.4098 28.0202 79.895 28.2089 79.4563 28.3545L78.867 27.7653C78.1856 27.0871 77.2118 26.7982 76.2737 26.9943L71.4996 27.9524C70.4507 28.206 69.659 28.9708 69.3815 29.9629ZM97.9718 57.2024L97.9701 57.2006L71.8385 31.0203C71.7321 30.9142 71.6921 30.7621 71.7318 30.6204C71.7714 30.4787 71.8845 30.3694 72.0275 30.3347L76.7634 29.3853C76.907 29.3553 77.0461 29.3966 77.1432 29.4932L78.2475 30.5975C78.5502 30.9002 78.9895 31.0222 79.405 30.9188C79.8625 30.8051 80.7036 30.5327 81.91 30.0473C83.885 29.2527 86.1888 28.1361 88.803 26.6431C96.2249 22.4046 104.671 16.0084 113.997 7.02002C114.791 6.24727 116.049 6.24727 116.838 7.01585L121.482 11.6431C122.237 12.4195 122.237 13.6775 121.468 14.4671C112.441 23.7966 106.127 32.3587 102.053 39.9731C100.617 42.6561 99.5646 45.0338 98.8358 47.0829C98.3905 48.335 98.1504 49.2127 98.0565 49.6928C97.972 50.1247 98.1266 50.5686 98.4611 50.8546L99.5838 51.8146C99.605 51.842 99.6462 51.9792 99.6196 52.1119L98.6588 56.9974C98.6299 57.1424 98.5217 57.2616 98.3778 57.305C98.2339 57.3485 98.0778 57.309 97.9718 57.2024Z"
			fill="#333333"
		/>
		<path
			d="M28.9459 65.1058C30.8984 65.5397 33.5786 65.7916 36.4474 65.7916C39.3162 65.7916 41.9964 65.5397 43.9489 65.1058C44.6839 64.9424 45.2869 64.7588 45.724 64.5712C45.2869 64.3837 44.6839 64.2 43.9489 64.0367C41.9964 63.6028 39.3162 63.3509 36.4474 63.3509C33.5786 63.3509 30.8984 63.6028 28.9459 64.0367C28.2109 64.2 27.6079 64.3837 27.1708 64.5712C27.6079 64.7588 28.2109 64.9424 28.9459 65.1058Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M24.2441 64.5712C24.2441 67.0662 29.4913 68.2323 36.4475 68.2323C43.4038 68.2323 48.6509 67.0662 48.6509 64.5712C48.6509 62.0762 43.4038 60.9102 36.4475 60.9102C29.4913 60.9102 24.2441 62.0762 24.2441 64.5712ZM36.4474 65.7916C33.5786 65.7916 30.8985 65.5397 28.946 65.1058C28.211 64.9424 27.608 64.7588 27.1708 64.5712C27.608 64.3837 28.211 64.2 28.946 64.0367C30.8985 63.6028 33.5786 63.3509 36.4474 63.3509C39.3163 63.3509 41.9964 63.6028 43.9489 64.0367C44.6839 64.2 45.2869 64.3837 45.724 64.5712C45.2869 64.7588 44.6839 64.9424 43.9489 65.1058C41.9964 65.5397 39.3163 65.7916 36.4474 65.7916Z"
			fill="#333333"
		/>
	</svg>
)

Svg.propTypes = {
	style: PropTypes.string,
	className: PropTypes.string,
}

Svg.defaultProps = {
	style: null,
	className: null,
}

export default Svg
